import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTimePipeConfig } from '../models/date-time-config-model';

@Pipe({name: 'dateTime'})

export class DateTimePipe implements PipeTransform {
  transform(date: string, config: DateTimePipeConfig = {dateFormat: '', timezoneFormat: ''}) {
    const datePipe = new DatePipe('ru');
    let timezoneFormat: string;

    switch (config.timezoneFormat) {
      case 'short':
        timezoneFormat = '(МСК)';
        break;
      case 'full':
        timezoneFormat = '(по московскому времени)';
        break;
      default:
        timezoneFormat = '';
    }

    if (!config.dateFormat) {
      config.dateFormat = `dd.MM.yyyy HH:mm:ss`;
    }

    return datePipe.transform(date, `${config.dateFormat} ${timezoneFormat}`);
  }
}
